export const studentProfilePath = (studentUuid) =>
  `/studentprofile?id=${encodeURIComponent(studentUuid)}`;

export default studentProfilePath;
